import './App.css';

import AccordionSec from "./Components/Accordion/Accordion";
import Foot from "./Components/Footer/Footer";
import Form from "./Components/Form/Form";
import Head from "./Components/Head/Head";
import Navigations from "./Components/NavBar/Navbar";
import Review from "./Components/Reviews/Reviews";
import Services from "./Components/Serviecs/Services";

function App() {

  return (
    <div>
      <Navigations />
      <Head />
      <Services /> 
      <Review />   
      <AccordionSec />
      <Form />
      <Foot />
    </div>
  );
}

export default App;
